import LazyLoad from "vanilla-lazyload";
import select from 'select-dom'

export const initLazyLoad = els => new LazyLoad({
  use_native: true
}, els)

/*
* Method to be used on vue wrappers or when the loading of images needs to be customly handled
* `wrapper` is the parent DOM element
*/
export const loadAllImages = wrapper => initLazyLoad(select.all('.image-2021__img[data-is-vue="true"]', wrapper)).loadAll()

export default el => {
  if(el.dataset.isVue){
    // Consider making it work under Vue wrappers as a vue component
    // At the moment is customly handled at the wrapper level (by importing the loadAllImages method)
  } else {
    initLazyLoad([el])
  }
}


